import { useMutation, useQuery } from '@tanstack/react-query'
import { startServices as startServicesAPI, deleteServices, authorize } from '../../service/wearAppAdmin'
import { isWearAppAvailable } from 'service/panelCornerDetection'

export const useWearAppAdminRequests = () => {
  const startServices = () => {
    return useMutation(['startServices'], {
      mutationFn: startServicesAPI,
      retry: false
    })
  }

  const stopServices = () => {
    return useMutation(['stopServices'], {
      mutationFn: deleteServices,
      retry: false
    })
  }

  const getAuthorisation = () => {
    return useQuery({
      queryKey: ['authorize'],
      queryFn: authorize,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    })
  }

  const wearAppAvailabilityRequest = ({ refetchInterval }) =>
    useQuery([], {
      queryFn: isWearAppAvailable,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchInterval
    })

  return {
    startServices: startServices(),
    stopServices: stopServices(),
    getAuthorisation,
    wearAppAvailabilityRequest
  }
}
